//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../../Components/MUIs';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */
/** Images Import */
import koshaLogo2 from '../../../../../Assets/Images/kosha-logo2.jpg';
import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
// 교육현황/교육자료 탭은 한라 전용 변경 사항이 없어 기존 TRA_NEW 구현을 그대로 재사용
import TRA_NEW_1Function from '../../TRA_NEW/TRA_NEW_01/TRA_NEW_01F';
import TRA_NEW_4Function from '../../TRA_NEW/TRA_NEW_04/TRA_NEW_04F';
import TRA_NEW_5Function from '../TRA_NEW_05_HAN/TRA_NEW_05_HANF';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSearchInfo,
  setSearchText,
} from '../../../../../Reducer/SearchReducer';

//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TRA_NEW_HAN(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);

  //#endregion

  //#endregion
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="MultiTrainingPage"
          searchYn="Y"
          addYn={props.value === 0 || props.value === 2 ? 'N' : 'Y'}
          saveYn={props.value === 1 ? 'Y' : 'N'}
          deleteYn={props.value === 0 || props.value === 2 ? 'N' : 'Y'}
          printYn={props.value === 2 ? 'N' : 'Y'}
          imageButtonYn={props.value === 2 ? 'Y' : 'N'}
          imageButtonUrl="https://portal.kosha.or.kr/archive/cent-archive/master-arch"
          imageButtonSrc={koshaLogo2}
          imageButtonAlt="산업안전포털 안전보건자료실"
          imageButtonSx={{
            p: 0.5,
            '& img': {
              maxHeight: '30px',
              maxWidth: '180px',
            },
          }}
          imageButtonTooltip={`안전보건 자료실은 산업 현장에서 사고를 예방하고 근로자의 건강을 지키기 위해 필요한 정보를 제공합니다.`}
          addClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setAddClick1(true);
            } else if (props.value === 1) {
              props.setAddClick5(true); // TBM 탭
            } else if (props.value === 2) {
              props.setAddClick4(true); // 교육자료 탭
            }
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick5(true); // TBM 탭
            } else if (props.value === 2) {
              props.setFilterClick4(true); // 교육자료 탭
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick5(true); // TBM 탭
            } else if (props.value === 2) {
              props.setSaveClick4(true); // 교육자료 탭
            }
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick1(true);
            } else if (props.value === 1) {
              props.setDeleteClick5(true); // TBM 탭
            } else if (props.value === 2) {
              props.setDeleteClick4(true); // 교육자료 탭
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick5(true); // TBM 탭
            } else if (props.value === 2) {
              props.setPrintClick4(true); // 교육자료 탭
            }
          }}
          conditions={
            props.value === 2
              ? [
                  // ADMIN이면 추가 combo
                  ...(props.userInfo.authCd === 'ADMIN'
                    ? [
                        {
                          type: 'combo',
                          name: '회사',
                          items: searchInfo.coList,
                          value: searchInfo.coCd,
                          onChange: async (e) => {
                            await props.handleCoChange(e);

                            if (props.value === 0) {
                              await props.setSearchClick1(true);
                            } else if (props.value === 1) {
                              await props.setSearchClick5(true); // TBM 탭
                            } else if (props.value === 2) {
                              await props.setSearchClick4(true); // 교육자료 탭
                            }
                          },
                        },
                      ]
                    : []),
                  {
                    type: 'combo',
                    name: '사업장',
                    items: searchInfo.custList,
                    value: searchInfo.custCd,
                    onChange: async (e) => {
                      await props.handleCustChange(e);

                      if (props.value === 0) {
                        await props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        await props.setSearchClick5(true); // TBM 탭
                      } else if (props.value === 2) {
                        await props.setSearchClick4(true); // 교육자료 탭
                      }
                    },
                  },
                ]
              : [
                  {
                    type: 'datePicker',
                    views: ['year', 'month'],
                    openTo: 'month',
                    title: '월',
                    name: '조회년월',
                    value: dayjs(
                      `${searchInfo.year}-${searchInfo.month}`,
                      'YYYY-MM'
                    ),
                    onChange: async (date) => {
                      if (date) {
                        dispatch(
                          setSearchInfo({
                            year: dayjs(date).format('YYYY'),
                            month: dayjs(date).format('MM'),
                          })
                        );
                        if (props.value === 0) {
                          await props.setSearchClick1(true);
                        } else if (props.value === 1) {
                          await props.setSearchClick5(true); // TBM 탭
                        } else if (props.value === 2) {
                          await props.setSearchClick4(true); // 교육자료 탭
                        }
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY-MM',
                  },
                  // ADMIN이면 추가 combo
                  ...(props.userInfo.authCd === 'ADMIN'
                    ? [
                        {
                          type: 'combo',
                          name: '회사',
                          items: searchInfo.coList,
                          value: searchInfo.coCd,
                          onChange: async (e) => {
                            await props.handleCoChange(e);

                            if (props.value === 0) {
                              await props.setSearchClick1(true);
                            } else if (props.value === 1) {
                              await props.setSearchClick5(true); // TBM 탭
                            } else if (props.value === 2) {
                              await props.setSearchClick4(true); // 교육자료 탭
                            }
                          },
                        },
                      ]
                    : []),
                  {
                    type: 'combo',
                    name: '사업장',
                    items: searchInfo.custList,
                    value: searchInfo.custCd,
                    onChange: async (e) => {
                      await props.handleCustChange(e);

                      if (props.value === 0) {
                        await props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        await props.setSearchClick5(true); // TBM 탭
                      } else if (props.value === 2) {
                        await props.setSearchClick4(true); // 교육자료 탭
                      }
                    },
                  },
                  ...(props.value === 0
                    ? [
                        {
                          type: 'checkbox',
                          name: '전체인원보기',
                          checked: !!props.allMemberView1,
                          onChange: async (checked) => {
                            props.setAllMemberView1(!!checked);
                            await props.setSearchClick1(true);
                          },
                        },
                      ]
                    : []),
                ]
          }
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="교육현황"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />

                  <Tab
                    label="TBM일지"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    {...A11yProps(2)}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          style={{
                            fontSize: '0.95rem',
                            fontWeight: 'bold',
                            color: '#000',
                            whiteSpace: 'nowrap', // ✅ 교육자료는 무조건 한줄
                          }}
                        >
                          교육자료
                        </span>
                        {props.value === 2 && (
                          <Box
                            sx={{
                              ml: 1,
                              backgroundColor: '#fff8e1',
                              px: 1,
                              borderRadius: '4px',
                              border: '1px solid #ffe082',
                              color: '#e65100',
                              fontWeight: 500,
                              fontSize: '0.75rem',
                              maxWidth: 250, // ✅ 원하는 너비 제한
                              whiteSpace: 'normal', // ✅ 2줄 허용
                              lineHeight: 1.2, // ✅ 줄간격 조금 줄임
                            }}
                          >
                            * 교육자료를 다중 소속에 일괄 등록할 경우 오른쪽{' '}
                            <u>추가버튼</u>을 이용해주세요.
                          </Box>
                        )}
                      </Box>
                    }
                  />
                </Tabs>
              </Box>

              <CustomTabPanel value={props.value} index={0}>
                <TRA_NEW_1Function
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  validateSelection={props.validateSelection}
                  allMemberView1={props.allMemberView1}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <TRA_NEW_5Function
                  filterClick5={props.filterClick5}
                  setFilterClick5={props.setFilterClick5}
                  searchClick5={props.searchClick5}
                  setSearchClick5={props.setSearchClick5}
                  addClick5={props.addClick5}
                  setAddClick5={props.setAddClick5}
                  saveClick5={props.saveClick5}
                  setSaveClick5={props.setSaveClick5}
                  deleteClick5={props.deleteClick5}
                  setDeleteClick5={props.setDeleteClick5}
                  printClick5={props.printClick5}
                  setPrintClick5={props.setPrintClick5}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={2}>
                <TRA_NEW_4Function
                  filterClick4={props.filterClick4}
                  setFilterClick4={props.setFilterClick4}
                  searchClick4={props.searchClick4}
                  setSearchClick4={props.setSearchClick4}
                  addClick4={props.addClick4}
                  setAddClick4={props.setAddClick4}
                  saveClick4={props.saveClick4}
                  setSaveClick4={props.setSaveClick4}
                  deleteClick4={props.deleteClick4}
                  setDeleteClick4={props.setDeleteClick4}
                  printClick4={props.printClick4}
                  setPrintClick4={props.setPrintClick4}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default TRA_NEW_HAN;
